<template>
<div class="navbar modal modal-right fade modal-more-filters" id="advance_filter" tabindex="-1" role="dialog" aria-labelledby="advance_filter">
    <div class="modal-dialog modal-md" role="document" style="width: 360px;">
        <div class="modal-content" ref="section">
            <div class="modal-header bg-dark">
                <h6 class="modal-title">{{$t('More filters')}}</h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form>
                <div class="modal-body p-0 pb-5 px-0">

                    <div class="card card-collapsed border-0 shadow-none mb-0">
                        <div class="card-header header-elements-inline border-0 shadow-none p-0">
                            <div @click="toggleClick('f-type')" aria-expanded="false" class="f-type font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3" data-toggle="collapse" data-target="#collapse-product-type">
                                <div>{{$t("Sale Contact")}}</div>
                                <div class="header-elements">
                                    <div class="list-icons">
                                        <a :class="['list-icons-item', active.type ? 'rotate-180' : '']" data-action="collapse"></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="collapse ui-filter-list card-body" id="collapse-product-type">
                            <div class="filter-option">
                                <div class="form-group mb-0 pl-0">
                                    <div class="form-check" v-for="type in $parent.typeList" :key="type.id">
                                        <label class="form-check-label">
                                            <div class="uniform-checker">
                                                <span :class="integrationTypeSelect.includes(type.id)?'checked':''">
                                                    <input type="checkbox" class="form-input-styled" :checked="integrationTypeSelect.includes(type.id)" :value="type.id" v-model="integrationTypeSelect">
                                                </span>
                                            </div>
                                            <div class="d-flex">
                                                <!-- <i :style="type.style" :class="[type.icon, 'mr-2']"></i> -->
                                                <span :class="['badge badge-icon mr-2 p-0 text-center', type.badgeColor]" :style="type.style"  >
                                                    <i  :class="[type.icon,'m-0']"></i>
                                                </span>
                                                {{type.name}}
                                                <!-- {{$t(showProductTypeText(type.text))}} -->
                                            </div>
                                            
                                            
                                        </label>
                                    </div>
                                </div>
                                <div class="clear">
                                    <a href="javascript:void(0)" class="text-secondary" @click="clearFilter('integrationTypeSelect')">{{$t('Clear')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3">
                    <button type="button" class="btn btn-light" @click="clearFilter('all')">{{$t('Clear all filters')}}</button>
                    <button type="submit" class="btn btn-primary" data-dismiss="modal" @click="sendFilter">{{$t('Done')}}</button>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import VueTagsInput from 'vue-input-tag'


export default {
    name: "filters_more",
    data() {
        return {
            date: {
                singleDatePicker: 'range',
                opens: 'inline',
                autoApply: true,
            },
            active: {
                type: false,
                status: false,
                tags: false,
                createdate: false
            },
            autocompleteItemsTag: [],

            tag: [],
            integrationTypeSelect: this.$parent.filters.integrationType,
            
        }
    },
    components: {
        DateRangePicker,
        VueTagsInput
    },
    methods: {
        toggleClick(vm) {
            if ($('.' + vm).attr('aria-expanded') === "true") {
                switch (vm) {
                    case 'f-type':
                        this.active.type = false;
                        break;
                    case 'f-status':
                        this.active.status = false;
                        break;
                    case 'f-tags':
                        this.active.tags = false;
                        break;
                    case 'f-createdate':
                        this.active.createdate = false;
                        break;
                }

            } else {
                switch (vm) {
                    case 'f-type':
                        this.active.type = true;
                        break;
                    case 'f-status':
                        this.active.status = true;
                        break;
                    case 'f-tags':
                        this.active.tags = true;
                        break;
                    case 'f-createdate':
                        this.active.createdate = true;
                        break;
                }
            }
        },
        clearFilter(key) {
            this.integrationTypeSelect = []
        },
        applyDatePicker() {},
        tagsUpdate(newTags) {
            this.autocompleteItemsTag = [];
            this.$parent.filter.tags = newTags;
        },
        
        sendFilter() {
            this.$parent.filters.integrationType = this.integrationTypeSelect;
            let totalCount = this.integrationTypeSelect.length;
            // let totalCount = parseInt(countType) + parseInt(countSelect);
            this.$parent.isFiltersMore = false;

            this.$emit('sendfilter', {
                totalCount: totalCount,
                integration_type_id: this.integrationTypeSelect,
                q: this.$parent.$refs.changeCountTab.q,
            })
        },
        close() {
            // this.$parent.isFiltersMore = false;
        },
        setValue(value) {
            console.log('value', value);
        }
    },
    computed: {
        showTextPicker: function () {
            
        },
    },
    mounted: function () {

        // console.log(this.$parent.filter.productType);
    },
    watch: {
        tag: 'initItems',
    }
}
</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/settings/sale/sale-contact/assets/template/vuetable/FiltersMore.vue